export default "<div class=\"hint\">{{theMessage}}</div>\r\n\r\n\r\n"